<template>
  <div class="member-stay-wrapper">
    <transition name="scale">
      <div
        v-if="visible && config"
        class="member-stay-container"
        :style="{
          backgroundImage: `url(${config.image})`,
        }"
      >
        <div class="price-content flex items-center px-[16px] pb-[24px]">
          <div class="price-number text-[#FF6644] text-[36px] leading-[50px] font-medium mr-[30px]">
            ¥{{ config.title / 100 }}
          </div>
          <div class="flex flex-col">
            <div class="text-[18px] leading-[24px] font-medium text-[#72260E]">求职专属补贴</div>
            <div class="text-[14px] leading-[20px] text-[#B35720] mt-[4px]">限时10分钟立减</div>
          </div>
        </div>
        <div v-if="!!purchaseRecordData?.order_time" class="member-stay-countdown flex items-center justify-center">
          <span class="text-[13px] text-[#72260E] leading-[13px] mr-[8px]">优惠倒计时</span>
          <Countdown
            :start-time="purchaseRecordData?.order_time"
            :current-time="purchaseRecordData?.time_now"
            :duration="10 * 60"
            :unit-type="2"
            hidden-zero
          ></Countdown>
        </div>
        <div class="bottom-btns flex items-center gap-[8px]">
          <div class="btn-item cursor-pointer" @click="close">放弃优惠</div>
          <div class="btn-item cursor-pointer" @click="confirm">立享优惠</div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <div v-if="visible && config" class="mask"></div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Countdown from '@/components/Countdown.vue';
export default {
  name: 'MemberUrgeToStay',
  components: {
    Countdown,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('me', ['purchaseRecordData']),
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.member-stay-wrapper {
  .member-stay-container {
    @apply fixed left-0 bottom-0 right-0 top-0 z-[1001] pt-[163px] px-[23px] pb-[26px];
    margin: auto;
    width: 300px;
    height: 382px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .member-stay-countdown {
      @apply mt-[20px] w-full h-[32px] rounded-[4px] bg-[#FFF2EF] mb-[20px];
      ::v-deep(.countdown-container) {
        color: #72260e;
        gap: 8px;
        .countdown-item {
          @apply flex justify-center items-center w-[24px] h-[22px] rounded-[4px] bg-[#FFE6E0] text-[#ff6644] font-medium;
        }
      }
    }
    .bottom-btns {
      @apply absolute bottom-[26px] left-[23px] right-[23px];
      .btn-item {
        @apply flex-1 flex justify-center items-center h-[48px] rounded-full border-[1px] border-[#E5E6EC] border-solid text-[#4B596B] font-medium;
        &:last-child {
          @apply bg-[#FF6644] text-[#fff] border-none;
        }
      }
    }
  }
  .mask {
    @apply fixed top-0 left-0 w-full h-full z-[1000];
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
}
</style>
